import { useEffect } from 'react';

/**
 * Keeps the page out of search results while it is mounted (`<meta name="robots" content="noindex">`).
 * The public tool lives under `/app`; the page that search engines list is
 * music24.com/song-artwork-maker. nginx sends `X-Robots-Tag: noindex` for the route too.
 */
export function useNoIndex(): void {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex';
    document.head.appendChild(meta);
    return () => meta.remove();
  }, []);
}
